import { render, staticRenderFns } from "./table-no-record.vue?vue&type=template&id=249cc4a9&"
import script from "./table-no-record.vue?vue&type=script&lang=js&"
export * from "./table-no-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports